// Screenshot imports for each game
import cyrusBeanJump1 from '../assets/gamesScreenshorts/Cyrus Bean jump 1.webp';
import cyrusBeanJump2 from '../assets/gamesScreenshorts/Cyrus Bean jump 2.webp';
import cyrusBeanJump3 from '../assets/gamesScreenshorts/Cyrus Bean jump 3.webp';

import dandoRush1 from '../assets/gamesScreenshorts/Dando Rush 1.webp';
import dandoRush2 from '../assets/gamesScreenshorts/Dando Rush 2.webp';
import dandoRush3 from '../assets/gamesScreenshorts/Dando Rush 3.webp';

import draughts1 from '../assets/gamesScreenshorts/Draughts 1.webp';
import draughts2 from '../assets/gamesScreenshorts/Draughts 2.webp';
import draughts3 from '../assets/gamesScreenshorts/Draughts 3.webp.webp';

import carrom1 from '../assets/gamesScreenshorts/carrom1.webp';
import carrom2 from '../assets/gamesScreenshorts/carrom2.webp';
import carrom3 from '../assets/gamesScreenshorts/carrom3.webp';

import forestRush1 from '../assets/gamesScreenshorts/forest rush 1.webp';
import forestRush2 from '../assets/gamesScreenshorts/forest rush 2.webp';
import forestRush3 from '../assets/gamesScreenshorts/forest rush 3.webp';

import gunwars1 from '../assets/gamesScreenshorts/gunwars1.webp';
import gunwars2 from '../assets/gamesScreenshorts/gunwars2.webp';
import gunwars3 from '../assets/gamesScreenshorts/gunwars3.webp';

import omi1 from '../assets/gamesScreenshorts/omi 1.webp';
import omi2 from '../assets/gamesScreenshorts/omi 2.webp';
import omi3 from '../assets/gamesScreenshorts/omi 3.webp';

import pool1 from '../assets/gamesScreenshorts/pool1.webp';
import pool2 from '../assets/gamesScreenshorts/pool2.webp';
import pool3 from '../assets/gamesScreenshorts/pool3.webp';

import trapAndGo1 from '../assets/gamesScreenshorts/trap and go 1.webp';
import trapAndGo2 from '../assets/gamesScreenshorts/trap and go 2.webp';
import trapAndGo3 from '../assets/gamesScreenshorts/trap and go 3.webp';

// Map game titles to their 3 screenshots
export const GAME_SCREENSHOTS = {
  "Cyrus Bean Jump": [cyrusBeanJump1, cyrusBeanJump2, cyrusBeanJump3],
  "Dando Rush": [dandoRush1, dandoRush2, dandoRush3],
  "Draughts": [draughts1, draughts2, draughts3],
  "Carrom League": [carrom1, carrom2, carrom3],
  "Forest Rush": [forestRush1, forestRush2, forestRush3],
  "Gun Wars": [gunwars1, gunwars2, gunwars3],
  "Omi": [omi1, omi2, omi3],
  "Pool League": [pool1, pool2, pool3],
  "Trap and Goo": [trapAndGo1, trapAndGo2, trapAndGo3],
};
